import http from '@/utils/http';
const base_path = '/v2/tool/deliveryPosition';

/**
 * 获取投放位置列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDeliveryPositionApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
